// extracted by mini-css-extract-plugin
export default {"layout":"WelcomeViews_layout__vBA2G"};